/**
 * 索赔右侧方案展示 售后方案 组件（只读）
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import {Alert} from "antd";
import Lang from "@components/Lang/Lang";
import BtnSelect from '@components/BtnSelect/BtnSelect';
import {symbolMoneyUtil, toFixed2} from '@utils/utils';
import BankCardSelector from "@/components/BankCardSelector/BankCardSelector";
import "./claim.less";
/**
 * 索赔右侧方案组件 - 展示已处理的赔偿方案
 * @param {Object} model - 索赔单数据模型
 * @param {Object} values - 表单值对象
 * @param {String} snUit - 单位
 * @param disable 是否禁止编辑 默认否
 */
const ClaimRightPlan = ({ model = {}, values={}, changeClaimType,changeBank,disable=false}) => {
    const demageTypes = __getDictList("sale_po_claim_demage_order_claim_type");
    const mgPoInfoVO = model.mgPoInfoVO||{},buyerBankCardVO=model.buyerBankCardVO||{};
    // 格式化银行卡号
    const formatBankNo = function(bankNo){
        if(!bankNo || bankNo.length < 13){
            return bankNo || "-";
        }
        const prefix = bankNo.substring(0, 4);
        const suffix = bankNo.substring(bankNo.length - 4);
        return `${prefix} **** **** ${suffix}`;
    }
    return (<div className={"borderInfoCard"}>
        <div className={"black89 fw_700 font_16"}>{Lang({id:"ShouHouFangAn",default:"售后方案"})}</div>
        {/*总计*/}
        <Alert message={<div className={"black89"}>
            {Lang({id: "ShouHouTuiKuan",default: "售后退款"})}
            <span className={"ml_4"}>{mgPoInfoVO.wornQuantity} PCS * {symbolMoneyUtil(mgPoInfoVO.pcsPrice,mgPoInfoVO.currencySymbol)}，</span>
            <span className={"ml_2 mr_2"}>{Lang({id: "ZongJi",default: "总计"})}</span>
            {symbolMoneyUtil(model.refundAmountTotal, mgPoInfoVO.currencySymbol)}
        </div>} type="warning" showIcon />
        <div className={"mt_16"}>
            <BtnSelect list={demageTypes} disabled={model&&model.statusMg=="1"&&!disable?false:true}
                       initValue={model.claimType}
                       callBack={(v)=>changeClaimType&&changeClaimType(v)} />
        </div>
        {/* 现金模式时显示银行卡选择 */}
        {values.claimType=="20"&&<div className={"mt_16"}>
            {!disable&&model&&model.statusMg=="1"?<BankCardSelector buyerId={model.buyerId}
                                                          changeBank={changeBank}
                                                          showRequire={false}
            />:<div className={`flex-item-between itemBank onBank`}>
                <div>
                    {buyerBankCardVO.bankLogoUrl&&<div><img src={buyerBankCardVO.bankLogoUrl} height={24} /></div>}
                    <div className={"mt_4"}>
                        {buyerBankCardVO.bankName||"-"}
                    </div>
                    <div className={"mt_8"}>
                        {formatBankNo(buyerBankCardVO.bankNo)}
                    </div>
                </div>
            </div>}
        </div>}
    </div>)
};

export default ClaimRightPlan;

